import React from "react";
import PropTypes from "prop-types";
import styles from "./DropdownMenu.module.css";

export default function DropdownMenu({ options, onOptionClick }) {
  return (
    <ul className={`${styles.dropdownMenuShow} dropdown-menu show`}>
      {options.map((option, index) => (
        <li
          key={index}
          className={`${styles.dropdownItem} dropdown-item`}
          onClick={(e) => {
            e.stopPropagation(); // Prevent event bubbling

            if (onOptionClick) {
              onOptionClick(option); // Pass the click event to NavItem
            }
          }}
        >
          {option.label}
        </li>
      ))}
    </ul>
  );
}

DropdownMenu.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ).isRequired,
  onOptionClick: PropTypes.func.isRequired,
};
